export class NotMatchValidator {
    constructor(message) {
        this.message = message;
    }
    validate(pair) {
        return pair[0] === pair[1];
    }
}
//# sourceMappingURL=NotMatchValidator.js.map